<template>
  <v-row dense>
    <v-col lg="5">
      <v-menu
        v-model="menuStart"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="computedDataStartFormatted"
            label="Data inizio movimenti"
            prepend-inner-icon="mdi-calendar"
            readonly
            outlined
            dense
            v-bind="attrs"
            v-on="on"
            clearable
            @click:clear="dataStart = null"
          ></v-text-field>
        </template>
        <v-date-picker v-model="dataStart" no-title scrollable @input="menuStart = false"></v-date-picker>
      </v-menu>
    </v-col>
    <v-col lg="5">
      <v-menu
        v-model="menuEnd"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="computedDataEndFormatted"
            label="Data fine movimenti"
            prepend-inner-icon="mdi-calendar"
            readonly
            outlined
            dense
            v-bind="attrs"
            v-on="on"
            clearable
            @click:clear="dataEnd = null"
          ></v-text-field>
        </template>
        <v-date-picker v-model="dataEnd" no-title scrollable @input="menuEnd = false"></v-date-picker>
      </v-menu>
    </v-col>
    <v-col lg="2">
      <v-btn color="success" :loading="loading" @click.stop="onCerca">Cerca movimenti</v-btn>
    </v-col>  
  </v-row>
</template>

<script>
  import * as _ from 'lodash'

  export default {
    props: {
      disabled: Boolean,
      loading: {
        type: Boolean,
        default: false
      }
    },
    data: (vm) => ({
      menuStart: false,
      menuEnd: false,
      dataStartFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataEndFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataStart: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),      
      dataEnd: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
    }),
    computed: {
      computedDataStartFormatted () {
        return this.formatDate(this.dataStart)
      },
      computedDataEndFormatted () {
        return this.formatDate(this.dataEnd)
      }
    },
    watch: {
      dataStart (val) {
        this.dataStartFormatted = this.formatDate(this.dataStart)
      },
      dataStdataEndart (val) {
        this.dataEndFormatted = this.formatDate(this.dataEnd)
      }
    },
    methods: {
      onCerca() {
        this.$emit('cerca-movimenti', { start: this.dataStart, end: this.dataEnd })
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      }
    }
  }
</script>
